<div (click)="onClickCard.emit()" class="w-full my-2 flex items-center border rounded-full px-4 py-4 text-start text-sm cursor-pointer hover:bg-blue-100 duration-300 text-darkGray {{selected ? 'border-primary' : 'border-lightGray'}}">
  <ng-content></ng-content>
</div>
